import React from 'react'
import { IconButton, Stack, Typography, useTheme, useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J1LeftarrowC } from '@e3dc-react/icons'

/**
 * Header component for the details page. Displays a navigate button and the page title.
 * The navigate button is only shown on smaller screens (below 'md' breakpoint).
 */
const DetailsPageHeader: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  if (upMd) {
    return <Typography variant="h3">{t('ai360.details-page.title')}</Typography>
  }

  return (
    <Stack flexDirection="row" gap={2} alignItems="center">
      <IconButton onClick={() => navigate(-1)} sx={{ padding: 0 }}>
        <J1LeftarrowC sx={{ width: '30px', height: '30px', color: 'primary.main' }} />
      </IconButton>
      <Typography variant="h2">{t('ai360.details-page.title')}</Typography>
    </Stack>
  )
}

export default DetailsPageHeader
